import request from '@/utils/request'

/**
 * 查询客服配置列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getKefuList(params) {
    return request({
        url: '/kefu/kefu/api/list',
        method: 'get',
        params
    })
}
